import { obterHtml } from './api';
import { formatar } from './config';
import { avisarErro } from './aviso';
import { ocupar } from './botao';
import { abrirNoSheet, abrirSheet, fecharSheet, iniciarVaga } from './vaga';

// A lista de vagas de uma empresa em linhas (Views/FanPage/_VagasEmpresaV2.cshtml), na página da empresa e na Área do colaborador:
// "Ver mais" e os filtros trazem o pedaço ?parcial=vagas; os filtros são os chips da busca (popover no computador, painel de baixo
// no celular), aplicados na hora. No celular a vaga abre no painel de baixo, igual à busca; no computador o link leva à página da vaga.
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
const lerJson = id => { try { return JSON.parse($(id)?.textContent || 'null'); } catch { return null; } };
const fmt = n => Number(n).toLocaleString(document.documentElement.lang || 'pt-BR');
const ico = n => `<svg class="ico" aria-hidden="true"><use href="#i-${n}"></use></svg>`;

// caminho: o endereço da lista sem os filtros; anuncios: o total sem filtro; textos: semInternet e erroVagas; textosBusca: os da
// busca (busca-v2-textos); alturaFixa: o que fica preso no alto da tela; padrao: empresa e logo da linha que não traz os dela.
let _op = { caminho: '', anuncios: 0, textos: {}, textosBusca: {}, alturaFixa: () => 0, padrao: {}, vagaUrl: null };
let T = {};
let TE = {};

// ---------- "Ver mais" ----------
const comParcial = href => `${href}${href.includes('?') ? '&' : '?'}parcial=vagas`;
const idsDaLista = () => $$('#empLista > li[data-id]').map(li => +li.dataset.id);
let _carregando = false;

async function carregarMais() {
    const mais = $('empMais');
    if (_carregando || !mais) {
        return false;
    }
    _carregando = true;
    ocupar(mais);
    try {
        const modelo = document.createElement('template');
        modelo.innerHTML = await obterHtml(comParcial(mais.getAttribute('href')));
        // Um filtro trocou a lista enquanto a página chegava: estas linhas são da lista anterior.
        if (!mais.isConnected) {
            return false;
        }
        const lista = $('empLista');
        const novas = [...modelo.content.querySelectorAll('#empLista > li[data-id]')].filter(li => !idsDaLista().includes(+li.dataset.id));
        lista.append(...novas);
        const proximo = modelo.content.querySelector('.emp__pag');
        proximo ? mais.closest('.emp__pag').replaceWith(proximo) : mais.closest('.emp__pag').remove();
        return novas.length > 0;
    } catch {
        avisarErro(navigator.onLine === false ? TE.semInternet : TE.erroVagas);
        ocupar(mais, false);
        return false;
    } finally {
        _carregando = false;
    }
}

// ---------- filtros ----------
// O servidor manda os grupos que separam as vagas (empFiltros, junto da barra); as contagens são em anúncios.
let G = [];
let F = {};
let _rascunho = null;
const grupo = k => G.find(g => g.k === k);
const vazioDe = g => (g.tipo === 'toggle' ? false : []);
function lerFiltros() {
    G = lerJson('empFiltros') || [];
    F = Object.fromEntries(G.map(g => [g.k, g.tipo === 'toggle' ? g.sel.length > 0 : [...g.sel]]));
    requestAnimationFrame(bordasDaBarra);
}

// A barra é uma linha só: a borda esmaece do lado em que ainda há chip fora da vista.
function bordasDaBarra() {
    const b = $('empFbar');
    if (!b) {
        return;
    }
    b.classList.toggle('is-antes', b.scrollLeft > 2);
    b.classList.toggle('is-mais', b.scrollLeft + b.clientWidth < b.scrollWidth - 2);
}
// Os mesmos códigos e a mesma ordem da URL do servidor (os grupos na ordem em que chegaram).
const qsDe = f => G.flatMap(g => (g.tipo === 'toggle' ? (f[g.k] ? [`${g.k}=sim`] : []) : f[g.k].map(v => `${g.k}=${encodeURIComponent(v)}`))).join('&');
const enderecoDe = f => {
    const qs = qsDe(f);
    return `${_op.caminho}${qs ? '?' + qs : ''}`;
};

// optsTpl da busca: caixa de seleção, a contagem e, nos filtros com busca, o campo e "Ver mais".
function opcoesHtml(g, f, aoVivo) {
    if (g.tipo === 'toggle') {
        return `<label class="opt"><input type="checkbox" data-k="${g.k}" ${f[g.k] ? 'checked' : ''}><span class="opt__l">${esc(T.pcdOpcao)}</span><span class="opt__n">${fmt(g.n || 0)}</span></label>`;
    }
    const rotuloBusca = esc(formatar(T.buscarEm, g.label.toLowerCase()));
    return `${g.busca ? `<div class="fsearch">${ico('search')}<input type="search" placeholder="${rotuloBusca}" aria-label="${rotuloBusca}" data-fsearch></div>` : ''}
    ${g.ops.map(([v, l, q, dica], i) => `<label class="opt" ${i >= 6 && g.busca ? 'data-more hidden' : ''}><input type="checkbox" name="f-${g.k}-${aoVivo ? 'l' : 'd'}" value="${esc(v)}" data-k="${g.k}" ${f[g.k].includes(v) ? 'checked' : ''}><span class="opt__l">${esc(l)}${dica ? `<small>${esc(dica)}</small>` : ''}</span>${q != null ? `<span class="opt__n">${fmt(q)}</span>` : ''}</label>`).join('')}
    ${g.busca && g.ops.length > 6 ? `<button class="linkbtn" type="button" data-showmore style="margin:0 8px">${esc(formatar(T.verMais, g.ops.length - 6))}</button>` : ''}`;
}

function lerOpcoes(raiz, alvo) {
    $$('input[data-k]', raiz).forEach(i => {
        const g = grupo(i.dataset.k);
        if (!g) {
            return;
        }
        if (g.tipo === 'toggle') {
            alvo[g.k] = i.checked;
        } else {
            const s = new Set(alvo[g.k]);
            i.checked ? s.add(i.value) : s.delete(i.value);
            alvo[g.k] = [...s];
        }
    });
}

// "Ver N anúncios" do painel do celular: com uma opção só, a contagem dela; com mais, "Ver vagas".
function rotuloAplicar() {
    const ligados = G.filter(g => (g.tipo === 'toggle' ? _rascunho[g.k] : _rascunho[g.k].length));
    let n = null;
    if (!ligados.length) {
        n = _op.anuncios;
    } else if (ligados.length === 1) {
        const g = ligados[0];
        if (g.tipo === 'toggle') {
            n = g.n || 0;
        } else if (_rascunho[g.k].length === 1) {
            n = (g.ops.find(o => o[0] === _rascunho[g.k][0]) || [])[2] || 0;
        }
    }
    $('facetApply').textContent = n == null ? T.verVagas : n === 1 ? T.verUmAnuncio : formatar(T.verAnuncios, fmt(n));
}

function abrirFiltro(k, ancora) {
    const g = grupo(k);
    if (!g) {
        return;
    }
    if (!ehCelular()) {
        const pop = $('pop');
        $('popT').textContent = g.label;
        $('popBody').innerHTML = opcoesHtml(g, F, true);
        pop.dataset.k = k;
        pop.hidden = false;
        $('popFoot').hidden = false;
        posicionarPop(true);
        ancora.setAttribute('aria-expanded', 'true');
        pop.querySelector('input')?.focus();
        return;
    }
    _rascunho = JSON.parse(JSON.stringify(F));
    $('sheetFacetT').textContent = g.label;
    $('sheetFacetBody').innerHTML = `<div style="padding:8px">${opcoesHtml(g, _rascunho, false)}</div>`;
    $('sheetFacet').dataset.k = k;
    rotuloAplicar();
    abrirSheet($('sheetFacet'), { marca: 'v2Filtro' });
}

// A barra fica no meio da página: o popover abre para cima quando não cabe embaixo e acompanha o chip na rolagem
// (fixo na janela, fecharia a cada rolada da roda dentro dele). Só troca de lado quando o lado atual fica pequeno.
function posicionarPop(abrindo = false) {
    const pop = $('pop');
    if (!pop || pop.hidden) {
        return;
    }
    const r = document.querySelector(`#empFbar [data-facet="${pop.dataset.k}"]`)?.getBoundingClientRect();
    const barra = $('empFbar')?.getBoundingClientRect();
    const limite = _op.alturaFixa();
    // Também fecha quando o chip sai pela lateral da barra, que rola de lado.
    if (!r || r.bottom < limite || r.top > window.innerHeight || (barra && (r.right < barra.left || r.left > barra.right))) {
        fecharPop({ devolverFoco: pop.contains(document.activeElement) });
        return;
    }
    const embaixo = window.innerHeight - r.bottom - 14;
    const emCima = r.top - limite - 14;
    const corpo = $('popBody');
    const alto = Math.min(460, pop.offsetHeight - corpo.clientHeight + corpo.scrollHeight);
    let acima = pop.dataset.acima === 'true';
    if (abrindo || (acima ? emCima : embaixo) < alto) {
        acima = alto > embaixo && emCima > embaixo;
        pop.dataset.acima = String(acima);
    }
    pop.style.maxHeight = Math.max(160, Math.min(460, acima ? emCima : embaixo)) + 'px';
    pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - pop.offsetWidth - 12)) + 'px';
    pop.style.top = (acima ? r.top - 6 - pop.offsetHeight : r.bottom + 6) + 'px';
}

// Devolve as caixas do popover aberto ao filtro que vale (sem refazer o HTML: o foco e o texto da busca ficam).
function sincronizarPop() {
    const pop = $('pop');
    const g = !pop.hidden && grupo(pop.dataset.k);
    if (!g) {
        fecharPop({ devolverFoco: false });
        return;
    }
    $$('input[data-k]', $('popBody')).forEach(i => { i.checked = g.tipo === 'toggle' ? !!F[g.k] : F[g.k].includes(i.value); });
}

export function fecharPop({ devolverFoco = true } = {}) {
    const p = $('pop');
    if (!p || p.hidden) {
        return false;
    }
    p.hidden = true;
    $$('[data-facet][aria-expanded="true"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (devolverFoco) {
        const k = p.dataset.k;
        setTimeout(() => document.querySelector(`#empFbar [data-facet="${k}"]`)?.focus({ preventScroll: true }), 0);
    }
    return true;
}

// O pedaço é trocado por inteiro: o foco que estava num controle dele volta ao do mesmo filtro na barra nova
// (o × some, então vai para o chip; "Limpar tudo" e o resto vão para o primeiro controle).
function chaveDoFoco(caixa) {
    const a = document.activeElement;
    return a && caixa.contains(a) ? a.dataset.toggle || a.dataset.facet || a.dataset.clearfacet || '*' : null;
}
function devolverFocoA(k) {
    const alvo = (k !== '*' && document.querySelector(`#empFbar [data-toggle="${k}"], #empFbar [data-facet="${k}"]`))
        || document.querySelector('#empVagas button, #empVagas a[href]');
    alvo?.focus({ preventScroll: true });
    mostrarNaBarra(alvo);
}

// A barra nova volta ao início da rolagem: o chip com o foco é trazido para a vista, fora do esmaecido (48 px).
function mostrarNaBarra(el) {
    const b = $('empFbar');
    if (!b || !el || !b.contains(el)) {
        return;
    }
    const rb = b.getBoundingClientRect();
    const re = el.getBoundingClientRect();
    if (re.right > rb.right - 48) {
        b.scrollLeft += re.right - (rb.right - 48);
    } else if (re.left < rb.left + 48) {
        b.scrollLeft -= rb.left + 48 - re.left;
    }
}

// Troca o pedaço da lista (barra, contagem, linhas e "Ver mais"); o endereço guarda os filtros, sem histórico novo.
let _filtroControlador = null;
// O endereço da lista que está na tela: se o pedido falha, o endereço e os filtros voltam a ele.
let _enderecoDaLista = null;
async function aplicar(f) {
    F = f;
    _filtroControlador?.abort();
    const controlador = new AbortController();
    _filtroControlador = controlador;
    const endereco = enderecoDe(f);
    _enderecoDaLista ??= window.location.pathname + window.location.search;
    history.replaceState(history.state, '', endereco);
    const caixa = $('empVagas');
    caixa.setAttribute('aria-busy', 'true');
    try {
        const html = await obterHtml(comParcial(endereco), { sinal: controlador.signal });
        if (_filtroControlador !== controlador) {
            return;
        }
        const foco = chaveDoFoco(caixa);
        caixa.innerHTML = html;
        _enderecoDaLista = endereco;
        lerFiltros();
        if (foco) {
            devolverFocoA(foco);
        }
        // O popover aberto continua preso ao chip do mesmo filtro (a barra foi refeita e o chip pode ter mudado de lugar).
        const pop = $('pop');
        if (!pop.hidden) {
            const chip = document.querySelector(`#empFbar [data-facet="${pop.dataset.k}"]`);
            chip?.setAttribute('aria-expanded', 'true');
            mostrarNaBarra(chip);
            posicionarPop();
        }
    } catch (e) {
        if (e.name !== 'AbortError' && _filtroControlador === controlador) {
            lerFiltros();
            history.replaceState(history.state, '', _enderecoDaLista);
            sincronizarPop();
            avisarErro(navigator.onLine === false ? TE.semInternet : TE.erroVagas);
        }
    } finally {
        if (_filtroControlador === controlador) {
            caixa.removeAttribute('aria-busy');
        }
    }
}

// ---------- eventos ----------
let _quadro = 0;
function iniciarEventos() {
    document.addEventListener('click', e => {
        const t = e.target;

        const linha = t.closest('#empLista a[data-vaga]');
        if (linha && cliqueComum(e) && ehCelular()) {
            e.preventDefault();
            abrirNoSheet(+linha.dataset.vaga);
            return;
        }

        const mais = t.closest('#empMais');
        if (mais && cliqueComum(e)) {
            e.preventDefault();
            const antes = idsDaLista().length;
            carregarMais().then(ok => {
                // Pelo teclado, o foco vai para a primeira vaga que chegou.
                if (ok && e.detail === 0) {
                    $$('#empLista > li[data-id]')[antes]?.querySelector('a')?.focus();
                }
            });
            return;
        }

        const chip = t.closest('#empFbar [data-facet]');
        if (chip) {
            const k = chip.dataset.facet;
            const aberto = !$('pop').hidden && $('pop').dataset.k === k;
            fecharPop({ devolverFoco: false });
            if (!aberto) {
                abrirFiltro(k, chip);
            }
            return;
        }
        // Fora do popover ele fecha, como em qualquer outro clique (aberto, ficaria com as caixas de antes).
        const limparUm = t.closest('#empFbar [data-clearfacet]');
        if (limparUm) {
            const g = grupo(limparUm.dataset.clearfacet);
            fecharPop({ devolverFoco: false });
            if (g) {
                aplicar({ ...F, [g.k]: vazioDe(g) });
            }
            return;
        }
        const alternar = t.closest('#empFbar [data-toggle]');
        if (alternar) {
            const k = alternar.dataset.toggle;
            fecharPop({ devolverFoco: false });
            aplicar({ ...F, [k]: !F[k] });
            return;
        }
        if (t.closest('#empVagas .js-clearall')) {
            fecharPop({ devolverFoco: false });
            aplicar(Object.fromEntries(G.map(g => [g.k, vazioDe(g)])));
            return;
        }
        if (t.closest('#popClose')) {
            fecharPop();
            return;
        }
        if (t.closest('#popClear')) {
            const g = grupo($('pop').dataset.k);
            if (g) {
                const f = { ...F, [g.k]: vazioDe(g) };
                $('popBody').innerHTML = opcoesHtml(g, f, true);
                aplicar(f);
            }
            return;
        }
        const verMais = t.closest('[data-showmore]');
        if (verMais) {
            $$('[data-more]', verMais.parentElement).forEach(x => x.removeAttribute('hidden'));
            verMais.remove();
            return;
        }
        const limparFiltro = t.closest('#facetClear');
        if (limparFiltro || t.closest('#facetApply')) {
            const el = $('sheetFacet');
            const k = el.dataset.k;
            const g = grupo(k);
            // "Limpar" desmarca e já aplica, como o "Ver N anúncios". Sem mudança (nada para limpar), os dois só fecham:
            // refazer a mesma lista perderia as vagas do "Ver mais".
            if (limparFiltro && g) {
                _rascunho[g.k] = vazioDe(g);
            }
            const f = _rascunho;
            const focar = () => document.querySelector(`#empFbar [data-facet="${k}"], #empFbar [data-toggle="${k}"]`)?.focus();
            if (qsDe(f) === qsDe(F)) {
                fecharSheet(el);
                focar();
                return;
            }
            // O painel sai do histórico com um Voltar: o endereço com o filtro só entra depois dele (senão o Voltar o leva).
            const volta = !!(el.dataset.marca && history.state?.[el.dataset.marca]);
            if (volta) {
                window.addEventListener('popstate', () => aplicar(f).then(focar), { once: true });
            }
            fecharSheet(el);
            if (!volta) {
                aplicar(f).then(focar);
            }
            return;
        }
        if (t.closest('#sheetFacet [data-close], #sheetFacet .sheet__grab')) {
            fecharSheet($('sheetFacet'));
            return;
        }
        if (!t.closest('#pop') && !$('pop').hidden) {
            fecharPop({ devolverFoco: false });
        }
    });

    document.addEventListener('change', e => {
        const i = e.target;
        // O campo de busca dentro do filtro também dispara change (ao sair dele): não é uma opção.
        if (!i.matches('input[data-k]')) {
            return;
        }
        if (i.closest('#popBody')) {
            const f = JSON.parse(JSON.stringify(F));
            lerOpcoes($('popBody'), f);
            aplicar(f);
        } else if (i.closest('#sheetFacetBody')) {
            lerOpcoes($('sheetFacetBody'), _rascunho);
            rotuloAplicar();
        }
    });

    document.addEventListener('input', e => {
        if (!e.target.matches('[data-fsearch]')) {
            return;
        }
        const tirar = s => s.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const q = tirar(e.target.value);
        const caixa = e.target.closest('.pop__body,#sheetFacetBody');
        $$('.opt', caixa).forEach(o => { o.hidden = q ? !tirar(o.textContent).includes(q) : o.hasAttribute('data-more'); });
        const mais = caixa.querySelector('[data-showmore]');
        if (mais) {
            mais.hidden = !!q;
        }
    });

    window.addEventListener('scroll', () => {
        if (_quadro) {
            return;
        }
        _quadro = requestAnimationFrame(() => {
            _quadro = 0;
            posicionarPop();
        });
    }, { passive: true });
    window.addEventListener('resize', () => {
        fecharPop({ devolverFoco: !!$('pop')?.contains(document.activeElement) });
        bordasDaBarra();
    });
    // A barra é trocada a cada filtro: a rolagem dela é ouvida no documento, na captura (o scroll não borbulha).
    document.addEventListener('scroll', e => {
        if (e.target.id === 'empFbar') {
            posicionarPop();
            bordasDaBarra();
        }
    }, { capture: true, passive: true });
}

// Link com ?vaga= no celular (o Voltar do login, o painel compartilhado): a lista rola até a linha e a vaga abre por cima.
function abrirVagaDoLink() {
    const id = +new URLSearchParams(window.location.search).get('vaga');
    const naLista = idsDaLista().includes(id);
    // Fora desta página da lista (a vaga veio pelo "Ver mais"), o servidor manda o endereço dela.
    if (!id || !ehCelular() || (!naLista && !_op.vagaUrl)) {
        return;
    }
    if (naLista) {
        document.querySelector(`#empLista > li[data-id="${id}"]`)?.scrollIntoView({ block: 'center' });
    }
    // O vaga.js já leu o "confirmar" ao iniciar: os dois saem do endereço que fica embaixo do painel.
    const u = new URL(window.location.href);
    u.searchParams.delete('vaga');
    u.searchParams.delete('confirmar');
    history.replaceState(history.state, '', u.pathname + u.search);
    // Fora da lista o cabeçalho espera a vaga: o número vem do endereço e pode ser de outra empresa (a vaga traz a dela).
    abrirNoSheet(id, naLista ? {} : { info: { id, titulo: '', empresa: '', logo: '', href: _op.vagaUrl, pills: '' } });
}

export function iniciarVagasEmpresa(opcoes) {
    _op = { ..._op, ...opcoes };
    T = _op.textosBusca || {};
    TE = _op.textos || {};
    iniciarVaga({
        textos: T,
        itens: '#empLista li',
        padrao: _op.padrao,
        lista: idsDaLista,
        total: () => +($('empLista')?.dataset.anuncios || 0) || idsDaLista().length,
        temMais: () => !!$('empMais'),
        carregarMais
    });
    lerFiltros();
    iniciarEventos();
    // A Inter chega depois da primeira pintura e muda a largura dos chips.
    document.fonts?.ready.then(bordasDaBarra);
    abrirVagaDoLink();
}
